// Chart animation follows the reader's motion setting (revamp plan §4): Recharts' mount and update animations run,
// except under `prefers-reduced-motion: reduce`, where they are off. Spread the result on every series:
//
//   const motion = useChartMotion();
//   <Area dataKey="totalAju" {...areaSeriesProps(color, fillId)} {...motion} />
//   <Pie data={slices} {...donutProps} {...motion} />
import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function subscribe(onChange: () => void) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const media = window.matchMedia(QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
}

const readReduced = () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(QUERY).matches;

/** True while the reader asks for reduced motion; follows the setting live. CSS covers anything else that moves
 *  (`motion-reduce:` utilities, a `prefers-reduced-motion` media query). */
function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, readReduced, () => false);
}

/** `{ isAnimationActive }` for a Recharts series: false under reduced motion. */
export function useChartMotion(): { isAnimationActive: boolean } {
  return { isAnimationActive: !useReducedMotion() };
}
